import { useMemo } from "react";
import moment from "moment-timezone";
import {
  isCircleVisible,
  useFetchUserCircles,
} from "@core/features/circle";
import { getDSTAwareAbbreviationFromTimezone } from "@core/features/timezones";
import { makeTimeslotFromId } from "@core/features/timeslots";
import { usePlatformStore } from "@platform/store";
import { useProgram } from "@platform/hooks/useProgram";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";
import { SchedulingCohortMessage } from "./SchedulingCohortMessage";

export function SchedulingCohortMessageContainer() {
  const user = usePlatformStore((s) => s.user);
  const { program } = useProgram();
  const { data: circlesData } = useFetchUserCircles({ user });
  const userTimezoneOption = useUserTimezoneOption();

  const visibleCircle = useMemo(
    () => (circlesData?.circles ?? []).find(isCircleVisible) ?? null,
    [circlesData?.circles]
  );

  const startTimeslot = useMemo(() => {
    if (
      !visibleCircle ||
      typeof visibleCircle.start_time_slot !== "number" ||
      !userTimezoneOption ||
      !program?.scheduled_engagement_start_date
    ) {
      return null;
    }

    return makeTimeslotFromId(
      visibleCircle.start_time_slot,
      program.scheduled_engagement_start_date,
      userTimezoneOption
    );
  }, [
    visibleCircle,
    userTimezoneOption,
    program?.scheduled_engagement_start_date,
  ]);

  if (
    !visibleCircle ||
    !startTimeslot ||
    !userTimezoneOption ||
    !program?.scheduled_engagement_start_date
  ) {
    return null;
  }

  const timezoneAbbreviation = userTimezoneOption.abbreviation
    ? getDSTAwareAbbreviationFromTimezone(
        userTimezoneOption,
        startTimeslot.local.start.dateString
      )
    : undefined;

  return (
    <SchedulingCohortMessage
      formattedTime={startTimeslot.local.start.formattedTime}
      day={startTimeslot.local.start.day}
      startDateLabel={moment(program.scheduled_engagement_start_date).format(
        "MMM Do"
      )}
      timezoneAbbreviation={timezoneAbbreviation || undefined}
    />
  );
}

export default SchedulingCohortMessageContainer;
